import { render } from "./DefaultCardComponent.vue?vue&type=template&id=3fd7ebe4"
import script from "./DefaultCardComponent.vue?vue&type=script&lang=js"
export * from "./DefaultCardComponent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__